import React, { PureComponent } from "react";
import axios from "axios";
import { server, config, checkAccess, STRIPE_KEY } from "../env";
import { setThemeMode, validURL } from "../tools/helper";
import { Link } from "react-router-dom";
import PageLoader from "../components/PageLoader";

import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(STRIPE_KEY);

export default class ViewInvoice extends PureComponent {
  state = {
    mode: localStorage.getItem("themeMode"),
    invoice_id: this.props.match.params.invoice_id,
    invoice: {},
    billing: {},
    isLoaded: false,
  };

  componentDidMount = async () => {
    this.setMode(this.state.mode);
    await axios
      .get(server + "/v1/invoice/read/" + this.state.invoice_id, config)
      .then((rsp) => {
        this.setState({
          invoice: rsp.data.payload.invoice,
          billing: rsp.data.payload.billing,
          isLoaded: true,
        });
      })
      .catch((err) => {
        checkAccess(err);
        this.setState({
          isLoaded: true,
        });
      });
  };

  setMode = (mode) => {
    setThemeMode(mode);
    this.setState({
      mode,
    });
  };

  pay = async () => {
    let invoice = this.state.invoice;

    if (validURL(invoice.hosted_url)) {
      window.location.href = invoice.hosted_url;
    } else {
      const stripe = await stripePromise;
      await stripe.redirectToCheckout({
        sessionId: invoice.hosted_url,
      });
    }
  };

  render() {
    const { invoice, billing } = this.state;
    return (
      <div className="main-content">
        <div className="container-fluid">
          <div className="row justify-content-center">
            {Object.keys(invoice).length > 0 ? (
              <div className="col-12 col-lg-10 col-xl-8">
                <div className="header mt-md-5">
                  <div className="header-body">
                    <div className="row align-items-center">
                      <div className="col">
                        <h6 className="header-pretitle">Payments</h6>

                        <h1 className="header-title">
                          Invoice #{invoice.id.split("-")[4]}
                        </h1>
                      </div>
                      <div className="col-auto">
                        <Link
                          to="#"
                          className="btn btn-primary ms-2 lift"
                          onClick={this.pay}
                        >
                          Pay
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card card-body p-5">
                  <div className="row">
                    <div className="col text-end">
                      {invoice.status ? (
                        <div className="badge bg-success-soft">Paid</div>
                      ) : new Date(invoice.created) >
                        Date.now() - 1000 * 60 * 60 ? (
                        <div className="badge bg-warning-soft">Pending</div>
                      ) : (
                        <div className="badge bg-danger-soft">Expired</div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center">
                      <img
                        src="/favicon.ico"
                        alt="..."
                        className="img-fluid mb-4"
                        style={{ maxWidth: "2.5rem" }}
                      />

                      <h2 className="mb-2">Invoice from Proxies.GG</h2>

                      <p className="text-muted mb-6">
                        Invoice #{invoice.id.split("-")[4]}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <h6 className="text-uppercase text-muted">
                        Invoiced from
                      </h6>

                      <p className="text-muted mb-4">
                        <strong className="text-body">3xK Tech GmbH </strong>{" "}
                        <br />
                        Altenhofer Weg 21 <br /> 16244, Schorfheide <br />
                        Germany
                      </p>

                      <h6 className="text-uppercase text-muted">Invoiced ID</h6>

                      <p className="mb-4">#{invoice.id.split("-")[4]}</p>
                    </div>
                    <div className="col-12 col-md-6 text-md-end">
                      <h6 className="text-uppercase text-muted">Invoiced to</h6>

                      <p className="text-muted mb-4">
                        <strong className="text-body">
                          {billing.first_name + " " + billing.last_name}
                        </strong>
                        <br />
                        {billing.address} <br />
                        {billing.zip}, {billing.city} <br />
                        {billing.country}
                      </p>

                      <h6 className="text-uppercase text-muted">Due date</h6>

                      <p className="mb-4">
                        <time datetime="2018-04-23">
                          {new Date(Date.now() + 1000 * 60 * 60).toDateString()}
                        </time>
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="table-responsive">
                        <table className="table my-4">
                          <thead>
                            <tr>
                              <th className="px-0 bg-transparent border-top-0">
                                <span className="h6">Plan Name</span>
                              </th>
                              <th className="px-0 bg-transparent border-top-0">
                                <span className="h6">Quantity</span>
                              </th>
                              <th className="px-0 bg-transparent border-top-0">
                                <span className="h6">Data</span>
                              </th>
                              <th className="px-0 bg-transparent border-top-0 text-end">
                                <span className="h6">Cost</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="px-0">{invoice.plan_name}</td>
                              <td className="px-0">1</td>
                              <td className="px-0">{invoice.plan_data}GB</td>
                              <td className="px-0 text-end">
                                {invoice.plan_price}€
                              </td>
                            </tr>
                            <tr>
                              <td className="px-0 border-top border-top-2">
                                <strong>Total amount due</strong>
                              </td>
                              <td className="px-0 border-top border-top-2"></td>
                              <td
                                colspan="2"
                                className="px-0 text-end border-top border-top-2"
                              >
                                <span className="h3">
                                  {invoice.plan_price}€
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <hr className="my-5" />

                      <h6 className="text-uppercase">Notes</h6>

                      <p className="text-muted mb-0">
                        We really appreciate your business and if there’s
                        anything else we can do, please let us know! Also,
                        should you need us to add VAT or anything else to this
                        order, it’s super easy since this is a template, so just
                        ask!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-12 col-lg-10 col-xl-8">
                <PageLoader />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
